export const getNumber = (number) => {
    const min = 0;
    const max = number!==undefined ? number :  9;
    return Math.floor(Math.random() * (max - min + 1) + min);
}